import { useEffect } from 'react';
import { useMutation } from 'react-query';

import { axios } from '@/library/axios';
import type { BaseResponse } from '@/types';
import { displayError } from '@/utils/functions/displayError';

import type {
  CalculatePriceRequestBody,
  CalculatePriceResponse,
} from './types';

const calculatePrice = (
  payload: CalculatePriceRequestBody
): Promise<BaseResponse<CalculatePriceResponse, CalculatePriceRequestBody>> => {
  return axios<
    CalculatePriceRequestBody,
    BaseResponse<CalculatePriceResponse, CalculatePriceRequestBody>,
    CalculatePriceRequestBody
  >({
    url: '/fx/leads/price',
    method: 'post',
    data: {
      ...payload,
    },
  });
};

export const useCalculatePrice = () => {
  const { mutateAsync, error } = useMutation({
    mutationFn: calculatePrice,
  });

  useEffect(() => {
    displayError(error);
  }, [error]);

  return { calculatePrice: mutateAsync };
};
